import { CLASS_BG, CLASS_TEXT, DeltaTag } from "./PerfSharedUI";

const LABEL_MAP = {
  excellent: "Excelente", target: "Bom", attention: "Razoável",
  critical: "Crítico", unknown: "—",
};

/**
 * Big Lead→Deal card, showing overall conversion percentage with the
 * matching semaphore treatment and delta vs previous comparable period.
 */
export default function GlobalConversionCard({ data }) {
  const pct = data?.conversions?.lead_to_deal ?? 0;
  const cls = data?.classifications?.lead_to_deal ?? "unknown";
  const deltas = data?.deltas?.conversions || {};
  const emoji = pct > 15 ? "⭐"
    : pct >= 12 ? "🟢"
    : pct >= 8 ? "🟡"
    : pct >= 5 ? "🟠"
    : "🔴";
  return (
    <div className={`rounded-2xl border-2 p-6 lg:p-8 ${CLASS_BG[cls]}`} data-testid="global-conversion-card">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-semibold">
            Conversão global
          </div>
          <h3 className="font-display text-2xl">Lead → Negócio</h3>
        </div>
        <div className="text-3xl">{emoji}</div>
      </div>
      <div className="flex items-baseline gap-4">
        <div className={`font-display text-6xl leading-none ${CLASS_TEXT[cls]}`}>
          {pct.toFixed(1)}<span className="text-3xl">%</span>
        </div>
        <DeltaTag delta={deltas.lead_to_deal} />
      </div>
      <div className={`text-xs uppercase tracking-[0.15em] font-bold mt-3 ${CLASS_TEXT[cls]}`}>
        {LABEL_MAP[cls]}
      </div>
    </div>
  );
}
